// LoggerService.js
// Servicio singleton profesional de logging para CAPIVIO

class LoggerServiceClass {
    constructor() {
        if (!LoggerServiceClass.instance) {
            LoggerServiceClass.instance = this;
        }
        return LoggerServiceClass.instance;
    }

    info(message, meta = {}) {
        // Aquí puedes integrar con el sistema de logs profesional, backend, o consola
        // eslint-disable-next-line no-console
        console.info(`[INFO] ${message}`, meta);
    }

    warn(message, meta = {}) {
        // eslint-disable-next-line no-console
        console.warn(`[WARN] ${message}`, meta);
    }

    error(message, meta = {}) {
        // eslint-disable-next-line no-console
        console.error(`[ERROR] ${message}`, meta);
    }

    debug(message, meta = {}) {
        // eslint-disable-next-line no-console
        console.debug(`[DEBUG] ${message}`, meta);
    }

    // Puedes agregar métodos para enviar logs a un backend, archivo, etc.
}

const loggerInstance = new LoggerServiceClass();

export const LoggerService = {
    getInstance: () => loggerInstance,
    info: (...args) => loggerInstance.info(...args),
    warn: (...args) => loggerInstance.warn(...args),
    error: (...args) => loggerInstance.error(...args),
    debug: (...args) => loggerInstance.debug(...args)
};
